import { Component } from '@angular/core';

@Component({
  selector: 'fl-tracking',
  template: `
    <fl-navigation-performance-tracking></fl-navigation-performance-tracking>
    <fl-memory-leak-tracking></fl-memory-leak-tracking>
    <fl-synthetic-performance-tracking></fl-synthetic-performance-tracking>
  `,
})
export class TrackingComponent {}



// WEBPACK FOOTER //
// ./src/app/@shared/tracking/tracking.component.ts